import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';
import em from 'polished/lib/helpers/em';
import { Link} from 'react-static';
import { getRelativeUrl } from '@flow/utils/cleaners';
import { shuffleArray } from '@flow/utils/arrayUtils';

function tickerBuilder(endValue: number) {
  return keyframes`
    0% {
      transform: translate3d(100%, 0, 0);
      visibility: visible;
    }
    100% {
      transform: translate3d(${-endValue}%, 0, 0);
    }`;
}

const Wrapper = styled.div`
  overflow: hidden;
  border-top: 0.2em solid ${props => props.theme.highlightColor};
  border-bottom: 0.2em solid ${props => props.theme.highlightColor};
`;

const TickerWrapper = styled.div`
  position: relative;
  height: 9.2em;
  transform: translate3d(100%, 0, 0);
  
  &.animate {
    animation: ${props => tickerBuilder(props.animationEndLeftValue)} ${props => props.animationDuration}s linear infinite;
  }
`;

const TickerContainer = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  white-space: nowrap;
`;

const TickerItem = styled.div`
  display: inline-block;
  a {
    display: inline-block;
    font-family: Flow-Poster-Bold;
    font-size: 2.8em;
    line-height: ${em(3.2, 2.8)};
    white-space: nowrap;
    padding: ${em(3, 2.8)} ${em(4, 2.8)};
    
    &:${props => props.theme.hoverProperty} {
      background-color: ${props => props.theme.highlightColor};
    }
  }
`;

interface Item {
  title: string;
  url: string;
  slug: string;
}

interface State {
  items: Item[];
  width: number;
  animationDuration: number;
  animationEndLeftValue: number;
  showTicker: boolean;
}

interface Props {
  items: Item[];
  appLanguage: IAppLanguage;
}

class Ticker extends Component<Props, State> {

  _ticker: HTMLElement;

  constructor(props: Props) {
    super(props);

    this.state = {
      showTicker: false,
      items: [],
      animationDuration: 0,
      animationEndLeftValue: 0,
      width: 0
    };
  }

  componentDidMount() {
    this.setState({
      items: shuffleArray(this.props.items),
      showTicker: true,
    }, () => {
      this.updateWindowDimensions();
      window.addEventListener('resize', this.updateWindowDimensions);
    })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    let viewportW: number = Math.min(window.innerWidth, 1920);
    let tickerW: number = this._ticker.getBoundingClientRect().width;
    let tickerSlideCount: number = tickerW / viewportW;
    let animationDuration: number = 10 * tickerSlideCount;
    let animationEndLeftValue: number = tickerSlideCount * 100;
    this.setState({animationDuration, animationEndLeftValue});
  };

  render() {
    const {animationDuration, animationEndLeftValue, showTicker} = this.state;

    if (!showTicker) {
      return null;
    } else {
      return (
        <Wrapper>
          {this.state.items && this.state.items.length > 0 &&
          <TickerWrapper animationDuration={animationDuration} animationEndLeftValue={animationEndLeftValue} className={animationEndLeftValue && animationDuration ? 'animate' : ''}>
            <TickerContainer innerRef={ticker => {this._ticker = ticker}}>
              {this.state.items.map((item: Item, index: number) =>
                <TickerItem key={index}>
                  <Link to={getRelativeUrl(item.url)} prefetch={false}>
                  {item.title}
                </Link>
                </TickerItem>
              )}
            </TickerContainer>
          </TickerWrapper>
          }
        </Wrapper>
      )
    }
  }
}

export default Ticker;


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/components/ticker/Ticker.tsx